import React from 'react';
import { Input } from '@/components/ui/input';
import { Label, Section, Toggle } from '@/components/surveyAccess/accessProfileFields';

const NUMBERS = [
  ['max_failures', 'Wrong tries per visitor', 'access-ag-max-failures'],
  ['window_minutes', 'Counting window (minutes)', 'access-ag-window'],
  ['lockout_minutes', 'Lockout length (minutes)', 'access-ag-lockout'],
  ['max_failures_per_network', 'Wrong tries per network', 'access-ag-network'],
];

// Phase 4B — temporary lockout + sequential-guess block (client/POS level).
export const AntiGamingSettings = ({ form, set }) => {
  const ag = form.anti_gaming || {};
  return (
    <Section title="Anti-guessing protection" testid="access-anti-gaming-settings">
      <Toggle label="Temporarily lock a visitor after repeated wrong codes" checked={ag.enabled}
        onChange={(v) => set(['anti_gaming', 'enabled'], v)} testid="access-ag-enabled-switch" />
      {ag.enabled && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {NUMBERS.map(([key, label, testid]) => (
              <div key={key}>
                <Label>{label}</Label>
                <Input type="number" min="1" value={ag[key] ?? ''} onChange={(e) => set(['anti_gaming', key], e.target.value)} data-testid={testid} />
              </div>
            ))}
          </div>
          <p className="text-[11px] text-[#64748B]">
            Visitors are tracked by browser session and a scrambled (one-way hashed) IP. The network limit is higher so one person
            can't lock out a shared mall Wi-Fi.
          </p>
          <Toggle label="Block rapid sequential guessing (4+ near-consecutive codes within 2 minutes)" checked={ag.block_sequential}
            onChange={(v) => set(['anti_gaming', 'block_sequential'], v)} testid="access-ag-sequential-switch" />
        </>
      )}
    </Section>
  );
};
